<template>
  <div id="dashboard-calendar-premium" class="premium-calendar-container">
    <v-row>
      <v-col cols="12">
        <v-card class="glass-card calendar-main-card">
          <div class="glass-shine"></div>

          <v-card-title class="px-8 pt-8 pb-4" style="background-color: #3A67B1;">
            <div class="d-flex align-center w-100">

              <h3 class="calendar-title text-white">JCI India Calendar</h3>
              <v-spacer></v-spacer>
              <div class="calendar-badge">
                <v-icon x-small color="primary" class="mr-1">mdi-calendar-check</v-icon>
                National Events
              </div>
            </div>
          </v-card-title>

          <v-divider class="glass-divider"></v-divider>

          <v-card-text class="pa-6">
            <!-- Loading Overlay -->
            <v-fade-transition>
              <div v-if="CalenderLoadingFlag" class="calendar-loader-overlay">
                <div class="premium-spinner"></div>
                <div class="loading-text">SYNCING EVENTS</div>
              </div>
            </v-fade-transition>

            <div class="calendar-wrapper">
              <!-- Custom Navigation Toolbar -->
              <div class="calendar-nav-toolbar mb-6">
                <div class="nav-left">
                  <v-btn rounded depressed class="today-btn px-6 mr-4" @click="setToday">
                    Today
                  </v-btn>
                  <div class="nav-arrows">
                    <v-btn icon class="arrow-btn mr-2" @click="prev">
                      <v-icon>mdi-chevron-left</v-icon>
                    </v-btn>
                    <v-btn icon class="arrow-btn" @click="next">
                      <v-icon>mdi-chevron-right</v-icon>
                    </v-btn>
                  </div>
                  <h2 class="current-month ml-6">{{ CalenderOptions.MonthName }}</h2>
                </div>

                <v-spacer></v-spacer>

                <div class="nav-right">
                  <v-menu bottom left offset-y transition="scale-transition">
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn rounded depressed class="view-selector-btn" v-bind="attrs" v-on="on">
                        <span class="mr-2">{{ typeToLabel[type] }}</span>
                        <v-icon small>mdi-chevron-down</v-icon>
                      </v-btn>
                    </template>
                    <v-list class="view-menu-list">
                      <v-list-item v-for="(label, key) in typeToLabel" :key="key" @click="type = key"
                        :class="{ 'active-item': type === key }">
                        <v-list-item-title>{{ label }}</v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                </div>
              </div>

              <!-- Actual Calendar Component -->
              <div class="calendar-content-sheet">
                <v-calendar ref="calendar" v-model="focus" color="var(--jci-navy)" :events="events"
                  :event-color="getEventColor" :type="type" @click:event="showEvent" @click:more="viewDay"
                  @click:date="viewDay" @change="updateRange" class="modern-calendar"></v-calendar>

                <!-- Event Detail Popup -->
                <v-menu v-model="selectedOpen" :close-on-content-click="false" :activator="selectedElement" offset-y
                  max-width="400px" content-class="event-detail-menu">
                  <v-card class="glass-card event-popup">
                    <div class="popup-header"
                      :style="`background: linear-gradient(135deg, ${selectedEvent.color || '#3A67B1'} 0%, #0A0F29 100%)`">
                      <v-btn icon dark x-small @click="selectedOpen = false" class="close-popup">
                        <v-icon>mdi-close</v-icon>
                      </v-btn>
                      <h4 class="popup-title">{{ selectedEvent.name }}</h4>
                    </div>

                    <v-card-text class="pa-6">
                      <div class="info-item mb-4">
                        <v-icon small class="mr-2" color="primary">mdi-text-subject</v-icon>
                        <p class="mb-0">{{ selectedEvent.description }}</p>
                      </div>

                      <div class="date-range-box">
                        <div class="date-item">
                          <div class="label">START</div>
                          <div class="value">{{ selectedEvent.startTxt }}</div>
                        </div>
                        <div class="date-divider"></div>
                        <div class="date-item text-right">
                          <div class="label">END</div>
                          <div class="value">{{ selectedEvent.endTxt }}</div>
                        </div>
                      </div>
                    </v-card-text>

                    <v-card-actions class="pa-4 pt-0">
                      <v-btn block rounded depressed class="confirm-btn" @click="selectedOpen = false">
                        ACKNOWLEDGE
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-menu>
              </div>
            </div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import common from "@/view/Common.vue";
import companyConfig from "@/company_config.json";

export default {
  mixins: [common],
  name: "DashboardCalender",
  props: {
    rows: {
      required: true
    }
  },
  data() {
    return {
      LoadingFlag: false,
      StartupLoadingFlag: false,
      CalenderLoadingFlag: false,

      CalenderOptions: {},

      focus: "",
      type: "month",
      typeToLabel: {
        month: "Month",
        week: "Week",
        day: "Day",
        "4day": "4 Days"
      },
      selectedEvent: {},
      selectedElement: null,
      selectedOpen: false,
      events: [],

      ZoneCode: "",
      LomCode: "",
      StartDate: "",
      EndDate: ""
    };
  },
  watch: {},
  mounted() {
    this.$refs.calendar.checkChange();
  },
  methods: {
    refreshPageData() {
      console.log("refreshPageData called");
    },
    viewDay({ date }) {
      this.focus = date;
      this.type = "day";
    },
    getEventColor(event) {
      return event.color;
    },
    setToday() {
      this.focus = "";
    },
    prev() {
      this.$refs.calendar.prev();
    },
    next() {
      this.$refs.calendar.next();
    },
    showEvent({ nativeEvent, event }) {
      const open = () => {
        this.selectedEvent = event;
        this.selectedElement = nativeEvent.target;
        requestAnimationFrame(() =>
          requestAnimationFrame(() => (this.selectedOpen = true))
        );
      };

      if (this.selectedOpen) {
        this.selectedOpen = false;
        requestAnimationFrame(() => requestAnimationFrame(() => open()));
      } else {
        open();
      }

      nativeEvent.stopPropagation();
    },
    updateRange({ start, end }) {
      console.log("updateRange called");
      console.log("start=" + JSON.stringify(start));
      console.log("end=" + JSON.stringify(end));

      var StartDate = start.date;
      var EndDate = end.date;

      if (StartDate != this.StartDate || EndDate != this.EndDate) {
        var server_url = companyConfig.apiURL;
        var token = this.$session.get("token");
        token = token == (null || undefined) ? 0 : token;
        var add_url = server_url + "api/tenetative-event/lists";
        var upload = {
          UserInterface: 2,
          FromDate: StartDate,
          ToDate: EndDate,
          Zone: this.ZoneCode
        };
        console.log("upload=" + JSON.stringify(upload));
        console.log(
          "server_url=" +
          server_url +
          ", token=" +
          token +
          ", add_url=" +
          add_url
        );

        const thisIns = this;
        var output = "";
        var records = "";
        var successTxt = "";
        var errorTxt = "";
        var flag = 0;

        this.events = [];
        this.CalenderLoadingFlag = true;

        this.$http({
          url: add_url,
          method: "POST",
          data: upload,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token
          },
          onUploadProgress: function (progressEvent) {
            this.uploadPercentage = parseInt(
              Math.round((progressEvent.loaded / progressEvent.total) * 100)
            );
          }.bind(this)
        })
          .then(function (response) {
            console.log("response=" + JSON.stringify(response));

            thisIns.CalenderLoadingFlag = false;

            output = response.data.output;
            flag = response.data.flag;
            output = response.data.output;
            records = response.data.records;
            console.log("output=" + output + ", flag=" + flag);

            thisIns.StartDate = StartDate;
            thisIns.EndDate = EndDate;
            thisIns.CalenderOptions = records.TableOptions;

            if (flag == 1) {
              thisIns.events = records.TableData;

              // thisIns.toast("success", output);
            } else {
              // thisIns.toast("error", output);
            }
          })
          .catch(function (error) {
            console.log("error=" + error);
            thisIns.toast("error", error);
            thisIns.CalenderLoadingFlag = false;
          });
      }
    },
    rnd(a, b) {
      return Math.floor((b - a + 1) * Math.random()) + a;
    }
  },
  beforeMount() {
    var LomId = this.$session.get("LomId");
    LomId = LomId == (null || undefined) ? "" : LomId;
    this.LomCode = LomId;

    var ZoneCode = this.$session.get("ZoneId");
    ZoneCode = ZoneCode == (null || undefined) ? "" : ZoneCode;
    console.log("ZoneCode=" + ZoneCode);
    this.ZoneCode = ZoneCode;
  }
};
</script>
<style lang="scss">
.premium-calendar-container {
  --jci-navy: #3A67B1;
  --jci-aqua: #0097D7;
  --jci-gold: #EDBE38;
  --jci-seaform: #56BDA3;
  --jci-90-black: #414042;
  --jci-off-black: #0A0F29;
  --jci-white: #FFFFFF;

  font-family: 'Plus Jakarta Sans', 'Outfit', sans-serif !important;

  .glass-card {
    background: rgba(255, 255, 255, 0.7) !important;
    backdrop-filter: blur(20px) saturate(160%);
    border: 1px solid rgba(255, 255, 255, 0.6) !important;
    border-radius: 32px !important;
    box-shadow: 0 10px 40px -10px rgba(10, 15, 41, 0.05) !important;
    position: relative;
    overflow: hidden;
    transition: all 0.5s cubic-bezier(0.19, 1, 0.22, 1);

    .glass-shine {
      position: absolute;
      top: 0;
      left: -100%;
      width: 100%;
      height: 100%;
      background: linear-gradient(120deg, transparent, rgba(255, 255, 255, 0.3), transparent);
      transition: transform 1.2s ease;
      pointer-events: none;
    }

    &:hover .glass-shine {
      transform: translateX(100%);
    }
  }

  .title-decoration {
    width: 10px;
    height: 40px;
    background: var(--jci-navy);
    border-radius: 5px;
  }

  .calendar-title {
    font-size: 1.8rem;
    font-weight: 800;
    letter-spacing: -1px;
    color: var(--jci-off-black);
  }

  .calendar-badge {
    padding: 6px 14px;
    background: rgba(58, 103, 177, 0.1);
    color: var(--jci-navy);
    border-radius: 12px;
    font-size: 0.75rem;
    font-weight: 800;
    text-transform: uppercase;
    letter-spacing: 1px;
  }

  .glass-divider {
    border-color: rgba(10, 15, 41, 0.05) !important;
  }

  // Navigation Toolbar
  .calendar-nav-toolbar {
    display: flex;
    align-items: center;

    .nav-left {
      display: flex;
      align-items: center;
    }

    .today-btn {
      background: var(--jci-white) !important;
      color: var(--jci-navy) !important;
      font-weight: 800 !important;
      text-transform: none !important;
      border: 1px solid rgba(58, 103, 177, 0.1) !important;
      box-shadow: 0 4px 12px rgba(10, 15, 41, 0.05) !important;
    }

    .arrow-btn {
      background: rgba(255, 255, 255, 0.5) !important;
      color: var(--jci-off-black) !important;
      box-shadow: 0 4px 10px rgba(10, 15, 41, 0.03) !important;

      &:hover {
        background: var(--jci-white) !important;
        color: var(--jci-navy) !important;
      }
    }

    .current-month {
      font-size: 1.5rem;
      font-weight: 800;
      color: var(--jci-navy);
      letter-spacing: -0.5px;
    }

    .view-selector-btn {
      background: var(--jci-navy) !important;
      color: var(--jci-white) !important;
      font-weight: 700 !important;
      text-transform: none !important;
      padding: 0 24px !important;
    }
  }

  // Calendar Component Overrides
  .calendar-content-sheet {
    background: rgba(255, 255, 255, 0.4) !important;
    border-radius: 24px;
    border: 1px solid rgba(255, 255, 255, 0.5);
    overflow: hidden;

    .v-calendar {
      background: transparent !important;

      .v-calendar-weekly__head {
        background: rgba(58, 103, 177, 0.05) !important;
        border-bottom: 1px solid rgba(10, 15, 41, 0.05) !important;

        .v-calendar-weekly__head-weekday {
          padding: 12px 0 !important;
          color: var(--jci-navy) !important;
          font-weight: 800 !important;
          font-size: 0.9rem !important;
          text-transform: uppercase;
        }
      }

      .v-calendar-weekly__day {
        border-right: 1px solid rgba(10, 15, 41, 0.03) !important;
        border-bottom: 1px solid rgba(10, 15, 41, 0.03) !important;
        transition: background 0.3s ease;

        &:hover {
          background: rgba(255, 255, 255, 0.6) !important;
        }
      }

      .v-present {
        .v-calendar-weekly__day-label {
          .v-btn {
            background-color: var(--jci-navy) !important;
            color: white !important;
          }
        }
      }
    }
  }

  // Loader
  .calendar-loader-overlay {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(255, 255, 255, 0.8);
    backdrop-filter: blur(10px);
    z-index: 10;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    .premium-spinner {
      width: 50px;
      height: 50px;
      border: 4px solid rgba(58, 103, 177, 0.1);
      border-top: 4px solid var(--jci-navy);
      border-radius: 50%;
      animation: spin 1s linear infinite;
      margin-bottom: 20px;
    }

    .loading-text {
      font-weight: 800;
      color: var(--jci-navy);
      letter-spacing: 2px;
      font-size: 0.8rem;
    }
  }

  // Event Detail Popup
  .event-popup {
    border-radius: 24px !important;
    overflow: hidden;
    border: none !important;

    .popup-header {
      padding: 24px;
      position: relative;

      .close-popup {
        position: absolute;
        top: 12px;
        right: 12px;
      }

      .popup-title {
        color: white;
        font-weight: 800;
        font-size: 1.2rem;
        margin: 0;
        line-height: 1.3;
      }
    }

    .info-item {
      display: flex;
      align-items: flex-start;
      color: var(--jci-90-black);
      font-weight: 600;
      line-height: 1.6;
    }

    .date-range-box {
      background: rgba(10, 15, 41, 0.03);
      padding: 16px;
      border-radius: 16px;
      display: flex;
      align-items: center;
      justify-content: space-between;

      .date-item {
        .label {
          font-size: 0.65rem;
          font-weight: 800;
          color: var(--jci-navy);
          margin-bottom: 4px;
        }

        .value {
          font-size: 0.95rem;
          font-weight: 700;
          color: var(--jci-off-black);
        }
      }

      .date-divider {
        width: 1px;
        height: 30px;
        background: rgba(10, 15, 41, 0.1);
      }
    }

    .confirm-btn {
      background: var(--jci-navy) !important;
      color: white !important;
      font-weight: 800 !important;
      height: 48px !important;
      letter-spacing: 1px !important;
    }
  }
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

// Global Menu Overrides for the View Selector
.view-menu-list {
  border-radius: 16px !important;
  padding: 8px !important;

  .v-list-item {
    border-radius: 8px !important;
    margin-bottom: 4px !important;
    font-weight: 700 !important;

    &.active-item {
      background: rgba(58, 103, 177, 0.1) !important;
      color: var(--jci-navy) !important;
    }

    &:hover {
      background: rgba(58, 103, 177, 0.05) !important;
    }
  }
}
</style>